import React from 'react';



type Props = {
  className?: string;
}
export const ServiceProductCounterVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '20' height = '20' viewBox = '0 0 20 20' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path fill = 'white' d = 'M9.99111 15.8773L3.44 11.0697L2 12.1269L10 18L18 12.1269L16.5511 11.0614L9.99111 15.8773ZM10 13.7462L16.5422 8.93865L18 7.8731L10 2L2 7.8731L3.44889 8.93865L10 13.7462ZM10 4.12271L15.1022 7.8731L10 11.6235L4.89778 7.8731L10 4.12271Z' />
    </svg>
  );
};
